import React, { useState }  from 'react'
import { IoMdClose } from 'react-icons/io'
const ItemModal = (props) => {
    const {onClick2Close} = props
    return (
    <div className='modal'>
    <div className='modal-content w-[500px]'>
    <div className='text-right'>
      <button className='plane-btn' onClick={onClick2Close}><IoMdClose/></button>
    </div>
      aaaa
    </div>
    </div>
    )
} 
export default function ABC() {
    const [modal, setModal] = useState(false)
      return (
        <>
          <button className='plane-btn' onClick={()=>setModal(!modal)}>+</button><br/>
          {modal ? 
          <ItemModal onClick2Close={()=>setModal(!modal)}/>:''}
        </>
      )
  }